<template>
  <div class="jumbotron text-center bg-white">
    <b-card title="" sub-title=" ">
      <h2>{{ $t("impersonate-title") }}</h2>
      <h2>{{ name }}</h2>
      <b-card-text>
        <br />
        <br />
        <h6>
          {{ $t("impersonate-description") }}
        </h6>
      </b-card-text>
      <br />
      <div>
        <b-row>
          <b-col lg="6" class="pb-2"
            ><b-button @click="submit" variant="primary">{{
              $t("impersonate-submit-btn")
            }}</b-button></b-col
          >
          <b-col lg="6" class="pb-2"
            ><b-button @click="disconnect" variant="primary">{{
              $t("impersonate-disconnect-btn")
            }}</b-button></b-col
          >
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import ClientService from "../../services/client";
import conditionService from "../../services/condition";
export default {
  components: {},
  data() {
    return {
      name: "",
      data: undefined
    };
  },
  created() {
    this.impersonate();
  },
  methods: {
    impersonate() {
      const data = { token: this.$route.query.token };
      ClientService.impersonate(data)
        .then(result => {
          this.name = result.data.name;
          this.data = result.data;
          if (this.data != undefined) {
            this.getConditions(
              localStorage.getItem("email"),
              this.data.pkIxAntenne
            );
          }
        })
        .catch(function() {});
    },
    getConditions(email, pkAgency) {
      conditionService.getCondition(email, pkAgency).then(res => {
        if (res.success) {
          localStorage.setItem("conditions", JSON.stringify(res.activation));
        }
      });
    },
    submit() {
      var vue = this;
      if (this.data !== undefined) {
        localStorage.setItem("token", this.data.token);
        localStorage.setItem("pkClient", this.data.pkClient);
        localStorage.setItem("pkClient", this.data.pkClient);
        localStorage.setItem("pkIxAntenne", this.data.pkIxAntenne);
        localStorage.setItem("isPioAgency", true);

        localStorage.setItem("email", this.data.email);

        localStorage.setItem("isSharedHousing", this.data.isSharedHousing);
        vue.$store.commit("auth/token", localStorage.getItem("token"));
        vue.$store.commit("auth/email", localStorage.getItem("email"));
        vue.$store.commit("auth/pkClient", localStorage.getItem("pkClient"));
        vue.$store.commit(
          "auth/pkIxAntenne",
          localStorage.getItem("pkIxAntenne")
        );
        vue.$store.commit("auth/isPioAgency", true);
        vue.$store.commit("auth/isSharedHousing", this.data.isSharedHousing);
      }

      vue.$router.push("/home");
    },

    disconnect() {
      var vue = this;
      localStorage.removeItem("token");
      localStorage.removeItem("pkClient");
      localStorage.removeItem("isPioAgency");
      localStorage.removeItem("isSharedHousing");
      localStorage.removeItem("email");
      localStorage.removeItem("pkIxAntenne");
      vue.$store.commit("auth/removeToken");
      vue.$store.commit("auth/removePkClient");
      vue.$store.commit("auth/removePkIxAntenne");
      vue.$store.commit("auth/isPioAgency", null);
      vue.$store.commit("auth/isSharedHousing", null);
      vue.$store.commit("auth/removeEmail");
      vue.$router.push("/");
      console.log("disconnected");
    }
  }
};
</script>
